import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsDM: CultureInfo = {
  name: 'es-DM',
  displayName: 'español (Dominica)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-DM',
  parent: CultureInfoEs
};
